import PropTypes from 'prop-types';
import React from 'react';
import { Input } from 'react-toolbox';
import { Button } from 'react-toolbox/lib/button';
import cx from 'classnames';

import Card from 'components/Card';
import StyledSelect from 'components/StyledSelect';
import { DropdownDiv, ContainerDiv } from './styledComponents';
import { STATES, STATES_WITH_ABBREV } from 'config/constants';
import styles from 'styles/form';
import S from '../styles.scss';

const ChecklistPhaseInfo = (props) => {
  const {
    phase: {
      street_address,
      city,
      state,
      zip_code,
    },
    originalAddress,
    addressConfirmed,
    handleAddressConfirmed,
    handleNewAddress,
    submitNewAddress,
    assessmentScheduling,
  } = props;
  const statesSource = STATES.map(s => ({ value: s, label: s }));
  const stateValue = STATES.includes(state) ? state : STATES_WITH_ABBREV[state];
  const largeInput = cx(styles.inputs, styles.largeInput);
  const smallInput = cx(styles.inputs, styles.smallInput);

  return (<Card className={S.card}>
    <div className={S.headerContainer}>
      <h4 className={S.title}>Scheduling Checklist Phase Info</h4>
    </div>
    <div className={S.checklistContainer}>
      <p>
        { /* eslint-disable max-len */ }
        The {assessmentScheduling ? 'assessment' : 'installation'} address I see here is <span className={S.checklistText}>{originalAddress}</span>.
        Is that correct?
      </p>
      <br />
      <Button
        label="YES"
        flat inverse ripple
        disabled={addressConfirmed}
        className={S.standardButton}
        onClick={() => handleAddressConfirmed(true)}
      />
      <Button
        label="NO"
        flat inverse ripple
        disabled={addressConfirmed === false}
        className={S.standardButton}
        onClick={() => handleAddressConfirmed(false)}
      />
    </div>
    {addressConfirmed === false && <ContainerDiv>
      <DropdownDiv condition={addressConfirmed || addressConfirmed === false}>
        <div className={S.checklistContainer}>
          <Input
            label="Street Address"
            className={largeInput}
            value={street_address}
            onChange={val => handleNewAddress('street_address', val)}
            required
          />
          <Input
            label="City"
            className={largeInput}
            value={city}
            onChange={val => handleNewAddress('city', val)}
            required
          />
          <StyledSelect
            className={largeInput}
            label="State"
            onChange={val => handleNewAddress('state', val)}
            options={statesSource}
            value={stateValue}
            placeholder={'Select State'}
            required
          />
          <Input
            label="Zip Code"
            className={smallInput}
            value={zip_code}
            onChange={val => handleNewAddress('zip_code', val)}
            required
          />
          <Button
            label="Correct Address"
            flat inverse ripple
            className={S.saveButton}
            onClick={() => submitNewAddress()}
          />
        </div>
      </DropdownDiv>
    </ContainerDiv>}
  </Card>);
};

ChecklistPhaseInfo.propTypes = {
  user: PropTypes.string,
  phase: PropTypes.object,
  assessmentScheduling: PropTypes.bool,
  originalAddress: PropTypes.string,
  addressConfirmed: PropTypes.bool,
  handleAddressConfirmed: PropTypes.func,
  handleNewAddress: PropTypes.func,
  submitNewAddress: PropTypes.func,
};

export default ChecklistPhaseInfo;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseSchedulingChecklist/components/checklistPhaseInfo.jsx